<template>
    <div class=" section_sectionWrapper">
        <div class="module-newSys">
            <div class="title"></div>
            <div class="sys-cont">
                <div class="sys-1 sys-img-size"></div>
                <div class="sys-2 sys-img-size"></div>
                <div class="sys-3 sys-img-size"></div>
                <!-- 底部 -->
                <div class="s-footer"></div>

            </div>

        </div>

    </div>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {


        }
    },
    watch: {

    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.module-newSys {
    position: relative;
    height: 100%;
    width: 100%;

    

    .title {

        width: 322px;
        height: 105px;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 109px;
        transform: translateX(-50%);
        background-image: url("../../assets/img/sys/title.png");
    }

    .sys-cont {
        // width: 950px;
        // height: 675px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 240px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 100px;
        width: 100%;

        .sys-img-size {
            width: 1242px;
            height: 801px;
        }

        .sys-1 {
            background-size: 100% 100%;
            background-image: url("../../assets/img/sys/n-sys-1.png");
            margin-left: 96px;
        }

        .sys-2 {
            background-size: 100% 100%;
            background-image: url("../../assets/img/sys/n-sys-2.png");

        }

        .sys-3 {
            background-size: 100% 100%;
            background-image: url("../../assets/img/sys/n-sys-3.png");

        }

    }


}

@media screen and (max-width: 1200px) {
    .module-newSys {
        .sys-cont {
            // top: 45% !important;
        }
    }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .module-newSys {
        .title {
        width: 290px !important;
        height: 94px !important;
        }

        .sys-cont {
            // width: 760px !important;
            // height: 540px !important;
            // top: 55% !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/newSys.vue